import React, { useCallback } from "react";

import { useSelector } from "react-redux";

import useOneClickStore, { OneClickStore } from "../../../Hooks/useOneClickStore";
import { selectFeatureFlags } from "../../../Store/SettingsState";
import { GTMDataLayerPush } from "../../../Util/GoogleTagManager";
import { AppMenuItem } from "../AppMenuItem";

type ExpressAppMenuProps = {
    isHeaderView?: boolean;
}

const ExpressAppMenu: React.FC<ExpressAppMenuProps> = ({ isHeaderView = false }) => {
    const featureFlags = useSelector(selectFeatureFlags);
    const isParaphrasingModeActive = useOneClickStore((store: OneClickStore) => store.isParaphrasingModeActive);
    const setIsParaphrasingModeActive = useOneClickStore((store: OneClickStore) => store.setIsParaphrasingModeActive);

    const isParaphrasingFeatureActive = featureFlags["paraphrasing"];
    const isParaphrasingItemActive = isParaphrasingFeatureActive && isParaphrasingModeActive;

    const handleSpellcheckItemClick = useCallback((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();

        if (!isParaphrasingModeActive) return;

        GTMDataLayerPush({ event: "app-menu", option: "express_spellcheck" });
        setIsParaphrasingModeActive(false);
    }, [isParaphrasingModeActive, setIsParaphrasingModeActive]);

    const handleParaphrasingItemClick = useCallback((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();

        if (!isParaphrasingFeatureActive || isParaphrasingModeActive) return;

        GTMDataLayerPush({ event: "app-menu", option: "express_rephrase" });
        setIsParaphrasingModeActive(true);
    }, [isParaphrasingFeatureActive, isParaphrasingModeActive, setIsParaphrasingModeActive]);

    return <>
        <AppMenuItem
            isActive={!isParaphrasingItemActive}
            iconPath="/assets/icons/appmenu/ai-corrector.svg"
            href="/"
            tooltip={isHeaderView ? undefined : "Korrigieren"}
            description={isHeaderView ? undefined : "Korrigieren"}
            type="corrector"
            onClick={handleSpellcheckItemClick}
        />
        <AppMenuItem
            isActive={isParaphrasingItemActive}
            isDisabled={!isParaphrasingFeatureActive}
            iconPath="/assets/icons/appmenu/ai-paraphraser.svg"
            href="/"
            tooltip={isHeaderView ? undefined : (isParaphrasingFeatureActive ? "Umformulieren" : "Bald verfügbar")}
            description={isHeaderView ? undefined : "Umformulieren"}
            type="paraphraser"
            onClick={handleParaphrasingItemClick}
        />
    </>;
};

export default ExpressAppMenu;